<template>
    <div class="search" v-if="search && search.query && search.query.period && search.query.businessUnit">
        <GridLoader :loading="loading" class="grid-loader"  :color="'#43425D'" ></GridLoader>
        <div v-if="result">
            <SearchName :search="search" :result="result" @removeSearch="onRemoveSearch" @importFile="onImportFile"></SearchName>
            <Import v-show="show_import" :search="search" @newDataImported="onNewDataImported" @closeImport="onShowImport"></Import>
            <Header :result="result" :reference="reference"></Header>
            <PictoContainer :result="result" :search="search"></PictoContainer>
            <div class="client-container stat-container"> 
                <Nouveaux :nbOfColumns="nbOfColumns" :result="result" :display="search.query.period.startDate != '' && search.query.period.startDate != null && search.query.period.endDate != '' && search.query.period.endDate != null" @refreshedChart="resizeBlocks()"></Nouveaux>
                <Ca :result="result" :search="search" :nbOfColumns="nbOfColumns" @refreshedChart="resizeBlocks()"></Ca>
            </div>
                <Revisite v-show="false" :result="result"></Revisite>
                <Reachat v-show="false" :result="result"></Reachat>
            <div class="client-container stat-container">
                <IrisCSP :result="result" :search="search" :nbOfColumns="nbOfColumns" @refreshedChart="resizeBlocks()"></IrisCSP>
            </div>
            <div class="client-container stat-container">
                <Carte :result="result" :nbOfColumns="nbOfColumns" @refreshedChart="resizeBlocks()"></Carte>
                <Atelier :result="result" :nbOfColumns="nbOfColumns" @refreshedChart="resizeBlocks()"></Atelier>
                <Segment :result="result" :nbOfColumns="nbOfColumns" @refreshedChart="resizeBlocks()" v-if="!$store.state.user.brands"></Segment>
                <Civilite :result="result"></Civilite> 
                <Canal :result="result" :nbOfColumns="nbOfColumns" @refreshedChart="resizeBlocks()"></Canal>
                <Categories :result="result" :nbOfColumns="nbOfColumns" @refreshedChart="resizeBlocks()" v-if="!$store.state.user.brands"></Categories>
                <Age :result="result" :display="result != null" :nbOfColumns="nbOfColumns" @refreshedChart="resizeBlocks()"></Age>
            </div>
            <Famille :result="result" :search="search" @changeTop="changeTopFamily" @changeMetric="changeMetricFamily" :top="topFamily" :metric="metricFamily"></Famille>
            <Brand :result="result" @changeTop="changeTopBrand" @changeMetric="changeMetricBrand" :top="topBrand" :metric="metricBrand"></Brand>
            <Constructeur :result="result"></Constructeur>
            <!--ConstructeurExpenses :result="result" :nbOfColumns="nbOfColumns" @refreshedChart="resizeBlocks()"></ConstructeurExpenses-->
            <ConstructeurHeatmap :result="result" @refreshedChart="resizeBlocks()"></ConstructeurHeatmap>
            <Produitn1 :result="result" :search="search"></Produitn1>
            <Produitn2 :result="result" :search="search"></Produitn2>
            <Shops :result="result" :search="search"></Shops>
            <Sector :result="result" :search="search"></Sector>
        </div>
    </div>
</template>

<script>
  import SearchName from './SearchName.vue'
  import Header from './Header.vue'
  import Revisite from './Revisite.vue'
  import Reachat from './Reachat.vue'
  import PictoContainer from './PictoContainer.vue'
  import Civilite from './Civilite.vue'
  import IrisCSP from './IrisCSP.vue'
  import Atelier from './Atelier.vue'
  import Nouveaux from './Nouveaux.vue'
  import Carte from './Carte.vue'
  import Brand from './Brand.vue'
  import Constructeur from './Constructeur.vue'
  // import ConstructeurExpenses from './ConstructeurExpenses.vue'
  import ConstructeurHeatmap from './ConstructeurHeatmap.vue'
  import Categories from './Categories.vue'
  import Ca from './Ca.vue'
  import Segment from './Segment.vue'
  import Canal from './Canal.vue'
  import Age from './Age.vue'
  import Famille from './Famille.vue'
  import Produitn1 from './Produitn1.vue'
  import Produitn2 from './Produitn2.vue'
  import axios from 'axios'
  import Import from '../Import.vue'
  import buildQuery from '../buildQuery'
  import Shops from './Shops.vue'
  import Sector from './Sector.vue'
  import GridLoader from 'vue-spinner/src/GridLoader.vue'



  export default {
    name: 'Results',
    components: {
      GridLoader,
      SearchName,
    Header, Revisite, Reachat, PictoContainer, Civilite,
    Atelier, Nouveaux, Carte, Brand, Constructeur, ConstructeurHeatmap, Categories,
    Ca, Segment, Canal, Age, Famille, Produitn1, Produitn2,
    Import, Shops, Sector, IrisCSP
    },
    data() { return {
      result: null,
      show_import: false,
      loading: false,
      last_request: '',
      CancelToken: axios.CancelToken,
      cancels: []
    }},
    props: {
      search: Object,
      reference: Object,
      nbOfColumns: Number,
      topFamily: Object,
      metricFamily: Object,
      topBrand: Object,
      metricBrand: Object
    },
    methods: {
        onRemoveSearch(search) {
          this.$emit('removeSearch', search)
        },
        onUpdateResult(result) {
          this.$emit('updateResult', {search: this.search, result: result})
        },
        onImportFile() {
          this.show_import = true
        },
        onNewDataImported(header, content) {
          let newImport = {}
          newImport[header] = {data:content, value: true}
          this.search.query.filters.push({imported:newImport})
          this.show_import = false
        },
        onShowImport() {
          this.show_import = !this.show_import
        },
        resizeBlocks() {
          document.querySelectorAll(".search-container:first-child .needResize").forEach(el => {
            let className = el.className
            if (className) {
              className = className.replace(" ", ".")
              let elements = document.querySelectorAll(`.search-container .${className}`)
              elements.forEach(el => el.style.height = '')
              if (elements.length > 1) {
                let maxHeight = Array.from(elements).reduce((a, b) => {
                  return Math.max(a, b.clientHeight)
                }, 0)
                elements.forEach(el => el.style.height = `${maxHeight}px`)
              }
            }
          })
        },
        generateUUID () {
            var d = new Date().getTime()
            if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
              d += performance.now()
            }
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
              var r = (d + Math.random() * 16) % 16 | 0 
              d = Math.floor(d / 16)
              return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
            })
        },
        loadAggregations() {
          this.cancelCurrentRequest()
          this.loading=true
          this.last_request = this.generateUUID()
          const requestUuid = this.last_request
          this.result = null
          
          const endpoints = ['/aggregation-snow-head', '/aggregation-snow-age', '/aggregation-snow-sales', '/aggregation-snow-shop-sector', '/aggregation-snow-shop-name', '/aggregation-snow-top-produits', '/aggregation-snow-vehicles', '/aggregation-snow-family', '/aggregation-snow-brand', '/aggregation-snow-categories', '/aggregation-snow-contactabilite', '/aggregation-snow-rfm', '/aggregation-snow-iris', '/aggregation-snow-civilities']
          // Seul cet endpoint fait autorité sur `hits.total` (= nombre de clients).
          // Les autres endpoints interrogent des index différents dont le hits.total
          // peut valoir autre chose (ex. nombre de tickets) : il ne faut jamais le laisser
          // écraser le compteur clients.
          const HITS_ENDPOINT = '/aggregation-snow-head'
          let requestsDone = 0

          const deepMerge = (target, source) => {
            Object.keys(source).forEach(key => {
              if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key]) && key !== 'buckets') {
                if (!target[key] || typeof target[key] !== 'object' || Array.isArray(target[key])) {
                  target[key] = {};
                }
                deepMerge(target[key], source[key]);
              } else {
                target[key] = source[key];
              }
            });
          };

          endpoints.forEach(endpoint => {
            axios.post(this.$store.state.user.url + endpoint, buildQuery(this.search.query), {
              headers: {
                'requestuuid': this.last_request,
                'Authorization': 'Bearer ' + this.$store.state.user.token
              },
              cancelToken: new this.CancelToken(c => {
                this.cancels.push(c)
              })
            })
            .then((response) => {
              // On ignore toute réponse issue d'un lot obsolète (changement de filtres
              // pendant qu'une requête déjà résolue au niveau réseau termine son .then).
              // Sans ce garde, une réponse d'une recherche précédente peut écraser this.result
              // et figer p.ex. le nombre de clients sur une valeur périmée.
              if (!response || !response.config || response.config.headers.requestuuid !== this.last_request) {
                return
              }
              if (response && response.data) {
                // On crée un nouvel objet pour forcer la réactivité de Vue 2 et déclencher les watchers
                const updatedResult = this.result ? { ...this.result } : { ...response.data };
                
                if (this.result && response.data.aggregations) {
                  const updatedAggregations = JSON.parse(JSON.stringify(this.result.aggregations));
                  deepMerge(updatedAggregations, response.data.aggregations);
                  updatedResult.aggregations = updatedAggregations;
                }
                
                // `hits` ne doit provenir QUE de l'endpoint autoritaire, sinon le nombre
                // de clients peut être écrasé par le hits.total d'un autre index (ex. tickets).
                if (endpoint === HITS_ENDPOINT) {
                  updatedResult.hits = response.data.hits;
                } else if (!this.result) {
                  // Premier responder non-autoritaire : on ne laisse pas son hits polluer
                  // l'affichage. Les composants gèrent l'absence de hits (affichent 0).
                  delete updatedResult.hits;
                }

                this.result = updatedResult;
                this.onUpdateResult(this.result);
              }
            })
            .finally(() => {
              // Un lot obsolète ne doit pas éteindre le spinner du lot courant.
              if (requestUuid !== this.last_request) {
                return
              }
              requestsDone++
              if (requestsDone === endpoints.length) {
                this.loading = false
              }
            })
          })
        },
        cancelCurrentRequest () {
            this.cancels.forEach(cancel => cancel())
            this.cancels = []
            this.loading = false
        },
        changeTopFamily(evt) {
          this.$emit('changeTopFamily', evt)
        },
        changeMetricFamily(evt) {
            this.$emit('changeMetricFamily', evt)
        },
        changeTopBrand(evt) {
            this.$emit('changeTopBrand', evt)
        },
        changeMetricBrand(evt) {
            this.$emit('changeMetricBrand', evt)
        }
    },
    created() {
      this.loadAggregations()
    },
    updated() {
      this.resizeBlocks()
    },
    watch: {
      search: {
        handler: function() {
          this.loadAggregations()
        },
      deep: true
      }
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/assets/styles/components/results.sass"
</style>